export default {"src":"/_next/static/media/pinterest.db091b7d.svg","height":512,"width":512};